module.exports = __webpack_public_path__ + "img/47.a9666f8e.jpg";